import { computed } from 'vue'
import { useStore } from 'vuex'

export function useShippingMethod() {
  const store = useStore()
  const checkout = computed(() => store.state.checkout?.checkout)
  const shippingMethods = computed(() => checkout.value?.shippings || [])
  const selectedShippingMethod = computed({
    get() {
      return checkout.value?.cart?.shipping ?? null
    },
    set(value) {
      store.dispatch('checkout/setShippingMethod', value)
    },
  })
  const selectedShippingLabel = computed(() => {
    const selected = selectedShippingMethod.value

    if (!selected) return null
  
    const method = shippingMethods.value.find(({ type }) => type === selected)
  
    return method?.description ?? null
  })

  return {
    shippingMethods,
    selectedShippingLabel,
    selectedShippingMethod,
  }
}
